import React from "react";

const Marker = ({ icon }) => (
  <div>
    <img src={icon} alt="" />
  </div>
);

export default Marker;
